module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 259
// module chunks = 0